export const EMAIL_CHARACHTER_LIMIT = 1024;
